module.exports = __webpack_public_path__ + "static/media/link_circle_background_icon.127a83f4.png";